// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__zxLBV","footer":"Form_footer__Q1jNr"};